/**
 * @file Purchase album layout.
 */

import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const PurchaseAlbumLayout = ({ children }) => children;

PurchaseAlbumLayout.propTypes = propTypes;

export default PurchaseAlbumLayout;
